import { Directive, ElementRef, EventEmitter, HostBinding, HostListener, Output, inject } from '@angular/core';

@Directive({ selector: '[airDragAndDrop]' })
export class DragAndDropDirective {
  private element = inject(ElementRef);

  @HostBinding('class.drag-active') isDragging: boolean;
  @Output() filesDropped = new EventEmitter<FileList>();

  @HostListener('dragover', ['$event'])
  onDragOver(e: DragEvent) {
    this.preventEventBubbling(e);
    this.isDragging = true;
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(e: DragEvent) {
    this.preventEventBubbling(e);

    if (this.element.nativeElement === e.target) {
      this.isDragging = false;
    }
  }

  @HostListener('drop', ['$event'])
  onDrop(e: DragEvent) {
    this.preventEventBubbling(e);
    this.isDragging = false;

    const files = e.dataTransfer?.files;
    if (files?.length) {
      this.filesDropped.emit(files);
    }
  }

  private preventEventBubbling(e: DragEvent): void {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  }
}
